/**
 * External dependencies
 */
import { get } from 'lodash';

export const getResourceId = state => get(state, 'ui.syncResource.resourceId', null);